module.exports = __webpack_public_path__ + "img/pause.05824590.svg";